import { MeResponse } from 'base/accounts_service';

export function getPricingParityOffer(
  member: MeResponse | undefined,
): Region | undefined {
  if (member?.countryCode && member?.parityP?.couponCode) {
    // if the user is logged in we identify their location based on their ip
    // we check for the coupon code to ensure they are in the set of users who
    // is eligible to use this coupon
    return REGIONS.find((region) => region.code === member.countryCode);
  }

  // if they're not we do it based on timezones
  // note this is logic to show the banner, the coupon will
  // NOT work unless their IP is also in the country
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return REGIONS.find((region) => region.timezone === timezone);
}

type Region = {
  code: string;
  name: string;
  flag: string;
  timezone: string;
};

const REGIONS = [
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', timezone: 'America/Sao_Paulo' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', timezone: 'Asia/Jakarta' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', timezone: 'Asia/Ho_Chi_Minh' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', timezone: 'Europe/Kiev' },
  { code: 'PH', name: 'Phillipines', flag: '🇵🇭', timezone: 'Asia/Manila' },
];
